import { Components, Theme } from '@mui/material/styles';

// Global component style overrides
export const componentOverrides: Components<Theme> = {
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
      },
      sizeLarge: {
        fontSize: '1.1rem',
        padding: '12px 24px',
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 12,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        transition: 'transform 0.2s, box-shadow 0.2s',
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: {
        fontWeight: 600,
      },
    },
  },
  MuiTypography: {
    styleOverrides: {
      h3: {
        fontWeight: 700,
        fontSize: '2.5rem',
      },
      h4: {
        fontWeight: 700,
        fontSize: '2rem',
      },
      h5: {
        fontWeight: 600,
        fontSize: '1.5rem',
      },
      h6: {
        fontWeight: 600,
        fontSize: '1.25rem',
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: ({ theme }) => ({
        backgroundImage: 'none',
        borderRadius: 12,
        backgroundColor: theme.palette.background.paper,
      }),
      elevation1: ({ theme }) => ({
        boxShadow: theme.palette.mode === 'dark'
          ? '0 2px 4px rgba(0,0,0,0.3)'
          : '0 2px 4px rgba(0,0,0,0.05)',
        backgroundColor: theme.palette.background.paper,
      }),
      elevation2: ({ theme }) => ({
        boxShadow: theme.palette.mode === 'dark'
          ? '0 4px 8px rgba(0,0,0,0.4)'
          : '0 4px 8px rgba(0,0,0,0.08)',
        backgroundColor: theme.palette.background.paper,
      }),
      elevation3: ({ theme }) => ({
        boxShadow: theme.palette.mode === 'dark'
          ? '0 8px 16px rgba(0,0,0,0.5)'
          : '0 8px 16px rgba(0,0,0,0.1)',
        backgroundColor: theme.palette.background.paper,
      }),
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        fontSize: '1rem',
      },
      head: {
        fontWeight: 600,
      },
    },
  },
};